export default __webpack_public_path__ + "static/media/15.1b8788d8.jpeg";